export default __webpack_public_path__ + "static/media/lisnr-logo-icon-white.7ad52f80.svg";